var $ = jQuery;
$('document').ready(function(){

    function monthlyPayment(p, n, i) {
        return p * i * (Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    $('form#idxthemes_mortage_calculator').submit(function(e){
        e.preventDefault();
        var idxthemesCalculatorOutputDiv = $('.idxthemes-calculator-output');
        idxthemesCalculatorOutputDiv.html('');

        var propertyPrice = parseInt($('#idxthemes_property_price').val());
        var downPaymentPercent = parseFloat($('#idxthemes_down_payment').val());
        var P = Math.round(propertyPrice * ((100 - downPaymentPercent) / 100));
        var downPaymentDollars = propertyPrice - P;
        var interestRate = parseFloat($('#idxthemes_interest_rate').val());
        var loanTerm = parseInt($('#idxthemes_loan_term').val());
        var I = interestRate / 100 / 12; //monthly interest rate
        var N = loanTerm * 12; //number of payments months
        var M; //monthly mortgage payment
        M = parseFloat(monthlyPayment(P, N, I)).toFixed(2);

        // build calculator results html
        var idxthemesCalculatorResults = '';
        idxthemesCalculatorResults += '<div class="idxthemes-calculator-results">';
        idxthemesCalculatorResults += '<h4>Calculation Results</h4>'
        idxthemesCalculatorResults += '<div class="left">Property Price:</div><div class="right">$' + numberWithCommas(propertyPrice) +'</div>';
        idxthemesCalculatorResults += '<div class="left">Down Payment:</div><div class="right">' + downPaymentPercent + '% ($' + numberWithCommas(downPaymentDollars) + ')</div>';
        idxthemesCalculatorResults += '<div class="left">Interest Rate:</div><div class="right">' + interestRate +  '%</div>';
        idxthemesCalculatorResults += '<div class="left">Loan Term</div><div class="right"><b>' + loanTerm + ' Years</b></div>';
        idxthemesCalculatorResults += '<div class="clearfix"></div>';
        idxthemesCalculatorResults += '<div class="divider"></div>';
        idxthemesCalculatorResults += '<div class="left">Monthly Payment:</div><div class="right"><b>$ ' + numberWithCommas(M) + '</b></div>';
        idxthemesCalculatorResults += '<div class="clearfix"></div>';
        idxthemesCalculatorResults += '</div>';
        idxthemesCalculatorOutputDiv.html(idxthemesCalculatorResults);
    });
});